import { useQuery } from '@tanstack/react-query';
import { fetchBlogs } from '@/services/DataService';
import type { BlogListAllQuery } from '@/services/DataService';
import { LIVE_STATUS_POLL_MS } from '@/utils/blogLiveStatus';

export const useBlogs = (query: BlogListAllQuery = {}) => {
    return useQuery({
        queryKey: [
            'blogs', query.page, query.page_size, query.needs_review,
            query.status, query.source, query.published,
            query.updated_from, query.updated_to, query.search,
        ],
        queryFn: () => fetchBlogs(query),
        // Re-read statuses every 15s while the list is on screen, like the old
        // Output screens. Polling only while something runs would miss an
        // item the server moves on just after an approval.
        refetchInterval: LIVE_STATUS_POLL_MS,
    });
};
